import { Divider, Flexbox } from '@sede-enterprise/shell-ds-react-framework';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import styled from 'styled-components';

export const SectionHeader = styled(Flexbox)`
  ${({ theme }) => `
  padding: 24px 64px;
  justify-content: space-between;
  background-color: ${theme.background.surface};
  width: 100%;
  flex-wrap: wrap; 
  @media screen and (max-width: ${cxTheme.breakpoints.tablet}px) {
    padding: 16px 24px;
  }
`}
`;

export const SectionLeft = styled(Flexbox)`
  ${({ theme }) => `
  flex-wrap: wrap; 
  gap: 24px;
`}
`;

export const SectionRight = styled(Flexbox)`
  ${({ theme }) => `
  flex-wrap: wrap; 
  gap: 24px;
  @media screen and (max-width: ${cxTheme.breakpoints.tablet}px) {
    padding: 16px 24px;
  }
`}
`;

export const MobileSectionHeader = styled(Flexbox)`
  ${({ theme }) => `
  padding: 24px 64px;
  justify-content: space-between;
  background-color: ${theme.background.surface};
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 2;
  @media screen and (max-width: ${cxTheme.breakpoints.tablet}px) {
    padding: 16px 24px;
  }
  transition: top 0.5s, box-shadow 0.7s;
`}
`;

export const CustomDivider = styled(Divider)`
  ${({ theme }) => `
  background-color: ${theme.background.surface};
  border-top: 1px solid ${theme.border.subtle};
`}
`;
